import { shippingClient } from 'domain/HttpClients';

export const fetch = (shipmentId, itineraryId = null) => {
  let url = `/api/shipments/shipment/${shipmentId}`;
  if (itineraryId) {
    url += `/${itineraryId}`;
  }
  return shippingClient.Get(url).send();
};

export const fetchQuoteShipments = (quoteId) => shippingClient.Get(`/api/shipments/shipment/quote/${quoteId}`).send();
